import i18n from '@/i18n'

export default {
  data: function () {
    return {
      viewportWidth: 0,
      dropdownExploreKey: false
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.updateViewportWidth)
  },
  created: function () {
    window.addEventListener('resize', this.updateViewportWidth)
  },
  mounted: function () {
    this.updateViewportWidth()
  },
  filters: {
    hrefNavbarItem: function (navItem) {
      if (navItem.externalUrl) {
        return navItem.externalUrl
      } else {
        const fullpath = process.env.BASE + navItem.redirectRoute
        return fullpath.replace('//', '/')
      }
    }
  },
  methods: {
    closeNavDropdowns: function () {
      this.isExploringMore = false
      this.isExploringTopic = false
      if (this.navbarItems) {
        this.navbarItems.forEach((navItem) => {
          if (navItem.isExploring) {
            navItem.isExploring = false
          }
        })
      }
    },
    followLink: function (navbarItem) {
      if (navbarItem.externalUrl) {
        window.open(navbarItem.externalUrl, '_blank')
      } else if (navbarItem.redirectRoute) {
        this.$router.push(navbarItem.redirectRoute)
      }
    },
    navBarString: function (displayTextKey) {
      return i18n.t(displayTextKey)
    },
    updateViewportWidth: function () {
      this.viewportWidth = window.innerWidth
    },
    toggleNavSubItemExplore: function (navbarItem) {
      if (navbarItem.isExploring) {
        this.closeExploreItem(navbarItem)
      } else {
        // closes other dropdowns so we dont have multiple open before opening a new one
        this.closeNavDropdowns()
        this.isExploringDropdown = true
        navbarItem.isExploring = true
        this.isExploringTopic = false
      }
      this.dropdownExploreKey = navbarItem.isExploring
    },
    closeExploreItem: function (navbarItem) {
      navbarItem.isExploring = false
      this.isExploringDropdown = false
    }
  }
}
